// lib/tour/layer.ts
//
// 🔴 Un clic dans la bulle de la visite n'est JAMAIS un clic « dehors ».
//
// Tout ce qui se ferme sur un clic ailleurs — panneaux Radix (`Sheet`,
// `Popover`, `DropdownMenu`), `useOutsideClick`, les détecteurs maison — doit
// consulter ce prédicat. Sinon « Suivant » refermerait la fenêtre que la visite
// est en train de montrer, et la cible de l'étape disparaîtrait sous la bulle.
// Radix juge « dedans » sur l'arbre REACT (`isPointerInsideReactTreeRef`) : la
// bulle, rendue par un provider monté dans le layout, n'en fait jamais partie.
// Garde : `lib/tour/tour-outside-click.guard.test.ts`.

/** Posé sur la racine de la couche de la visite. */
export const TOUR_LAYER_ATTR = "data-tour-layer";

export function isTourLayerTarget(target: EventTarget | null): boolean {
  if (!target || typeof Node === "undefined" || !(target instanceof Node)) return false;
  const el = target instanceof Element ? target : target.parentElement;
  return !!el?.closest(`[${TOUR_LAYER_ATTR}]`);
}
